import './App.css';
// import ParticlesBackground from './components/ParticlesBackground';
import TicTacToe from './components/TicTakToe';

function App() {
  return (
    <>
    <TicTacToe />
    {/* <ParticlesBackground /> */}
    </>
  );
}

export default App;
